import React from 'react';
import styles from './SkipLink.module.css';

export interface SkipLinkProps {
  /** ID of the target element to skip to (without #) */
  targetId?: string;
}

/**
 * Skip-to-content link for keyboard and screen reader users.
 * Implements WCAG 2.4.1 Bypass Blocks requirement.
 *
 * Hidden by default, appears when focused via Tab key.
 * Should be placed as the first focusable element in the page.
 *
 * @example
 * // In layout component (before header)
 * <SkipLink />
 * <Header />
 * <main id="main-content" tabIndex={-1}>
 *   ...
 * </main>
 *
 * @example
 * // Custom target
 * <SkipLink targetId="content" />
 */
const SkipLink: React.FC<SkipLinkProps> = ({ targetId = 'main-content' }) => {
  return (
    <a href={`#${targetId}`} className={styles.skipLink}>
      Skip to main content
    </a>
  );
};

export default SkipLink;
